const isBase64 = src => {
    return /^data:image\/(png|jpg|jpeg|gif|bmp|webp);base64,/.test(src)
}

export default isBase64